import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  containerProgress: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  circularProgress: {
    marginRight: '.7rem'
  },
  itemContainer: {
    '&:hover': {
      backgroundColor: '#e9e6e6'
    },
    '&:not(:last-child)': {
      borderBottom: '1px solid lightgray'
    }
  },
  itemContainerSelected: {
    backgroundColor: 'lightgray !important',
    '&:not(:last-child)': {
      borderBottom: '1px solid lightgray'
    }
  },
  textSpacing: {
    '& .MuiListItemText-secondary': {
      marginTop: 2
    }
  },
  emptyList: {
    textAlign: 'center',
    padding: 16
  },
  saveButton: {
    textTransform: 'none',
    fontSize: 16
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1
  }
}))

export default useStyles
